import React from "react";

export const TradePointModel = {
    id: null,
    trade_point_code: null,
    name: null,
    address: null,
    legal_entity: null,
    legal_address: null,
    chain: null,
    type: null,
    branch: null,
    geography: null
}